import React, { Component } from 'react';
import {getLogScale} from './SpectrumUtils.js';
import { Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import WetSlider from './WetSlider.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import Dropdown from 'react-dropdown';

const FREQUENCY_TO_X = {};

// draws the bars represnting the frequency spectrum 
class SpectrumPoints extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
            pts: [],
            updateRate: props.updateRate,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (this.state.updateRate !== nextProps.updateRate) {
            this.state.updateRate = nextProps.updateRate;
            clearInterval(this.timer);
            this.run();
        }
        return true;
    }
    
    componentDidMount() {

        this.run();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    run() {
        this.timer = setInterval(() => {
            if (this.props.sequencerEngine.playing) {
                let spectrum = Array.from(this.props.effect.getSpectrum());
                this.setState({pts: spectrum});
            }
        }, this.state.updateRate);
    }

    getXPositionForFrequency(frequency) {
        if (FREQUENCY_TO_X[frequency] !== undefined) {
            return FREQUENCY_TO_X[frequency];
        }
        let x =0;
        for (let i=0; i < frequency; i++) {
            x += this.props.getWidth(i);
        }

        FREQUENCY_TO_X[frequency] = x;

        return x;
    }

    getBucketRect(value, i) {
        let height = getLogScale(value, -160, 0, 1, 160);
        return (
            <Rect
              width={this.props.getWidth(i)}
              height={-2 * height}
              y={160}
              x={this.getXPositionForFrequency(i)}
              fill={this.rainbow(i)}/>
        );
    }

    rainbow(n) {
        return 'hsl(' + n + ',100%,50%)';
    }

    render() {
        return this.state.pts.map(
            (x, i) => this.getBucketRect(x, i));
    }
}

export default SpectrumPoints;
